const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

export const createLead = (body) =>
  request('/leads', { method: 'POST', body: JSON.stringify(body) });

export const getLeads = (rmUserId, includeTerminal = false) => {
  const params = new URLSearchParams();
  if (rmUserId) params.set('rmUserId', rmUserId);
  if (includeTerminal) params.set('includeTerminal', 'true');
  const qs = params.toString();
  return request(`/leads${qs ? `?${qs}` : ''}`);
};

export const getLeadDetail = (id) => request(`/leads/${id}`);

export const getLeadBrief = (id) => request(`/leads/${id}/brief`);

export const getLeadStats = (rmUserId) => {
  const query = rmUserId ? `?rmUserId=${encodeURIComponent(rmUserId)}` : '';
  return request(`/leads/stats${query}`);
};

export const logTouchpoint = (leadId, body) =>
  request(`/leads/${leadId}/touchpoints`, { method: 'POST', body: JSON.stringify(body) });

export const processAi = (leadId, touchpointId, body) =>
  request(`/leads/${leadId}/touchpoints/${touchpointId}/process-ai`, {
    method: 'POST',
    body: JSON.stringify(body)
  });

export const updateLeadStatus = (leadId, status, userId) =>
  request(`/leads/${leadId}/status`, { method: 'PUT', body: JSON.stringify({ status, userId }) });

export const updateInterestLevel = (leadId, interestLevel, userId) =>
  request(`/leads/${leadId}/interest`, { method: 'PUT', body: JSON.stringify({ interestLevel, userId }) });

export const updateLeadNotes = (leadId, notes, userId) =>
  request(`/leads/${leadId}/notes`, { method: 'PUT', body: JSON.stringify({ notes, userId }) });

export const updateLeadTags = (leadId, tags, userId) =>
  request(`/leads/${leadId}/tags`, { method: 'PUT', body: JSON.stringify({ tags, userId }) });

export const setNextFollowUp = (leadId, nextFollowUpAt, userId) =>
  request(`/leads/${leadId}/follow-up`, { method: 'PUT', body: JSON.stringify({ nextFollowUpAt, userId }) });

export const assignLead = (leadId, rmUserId, assignedByUserId) =>
  request(`/leads/${leadId}/assign`, { method: 'PUT', body: JSON.stringify({ rmUserId, assignedByUserId }) });

export const convertLead = (leadId, body) =>
  request(`/leads/${leadId}/convert`, { method: 'POST', body: JSON.stringify(body) });

export const dropLead = (leadId, dropReason, userId) =>
  request(`/leads/${leadId}/drop`, { method: 'POST', body: JSON.stringify({ dropReason, userId }) });

export const getOrCreateDraftClient = (leadId) =>
  request(`/leads/${leadId}/draft-client`, { method: 'POST' });

export const markProfileComplete = (leadId, userId) =>
  request(`/leads/${leadId}/profile/complete`, { method: 'POST', body: JSON.stringify({ userId }) });

export const startOnboarding = (leadId, plannerUserId, startedByUserId) =>
  request(`/leads/${leadId}/start-onboarding`, { method: 'POST', body: JSON.stringify({ plannerUserId, startedByUserId }) });
